export default {"src":"/_next/static/media/family-mod.be47b090.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};